import * as yup from 'yup';

export const CancelSalesInvoiceValidation = yup.object().shape({
    reason: yup.string().required('Provide a reason for cancelling this sales invoice'),
    raiseCreditNote: yup.string().oneOf(['YES', 'NO']).required('Required'),
});
